import t from "./contact-channels86.js";
import m from "./contact-channels87.js";
function a(r, i) {
  return t(m(r));
}
export {
  a as default
};
//# sourceMappingURL=contact-channels63.js.map
